class ShippingNotice extends window.BAO.CustomElement() {
  connectedCallback () {
    this.watchPurpleDot()
    this.watchOrderDeadline()
    this.setupListeners()
    this.checkView()
  }

  setupListeners () {
    this.checkView = this.checkView.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.checkView,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_SELECTED,
      this.checkView,
    )
  }

  checkView (event = null) {
    const variant = event?.detail?.variant

    if (variant) {
      const currentVariantEl = this.els.currentVariant.element

      currentVariantEl.setAttribute(
        'data-current-variant-available',
        variant.available,
      )
      currentVariantEl.setAttribute(
        'data-current-variant-restock',
        this.variantHasRestock(variant.id),
      )
    }

    setTimeout(() => {
      const orderDeadlineViewEl = this.els.orderDeadlineView?.element
      const preorderViewEl = this.els.preorderView?.element
      const restockViewEl = this.els.restockView?.element

      switch (this.view) {
        case 'instock':
          orderDeadlineViewEl?.setAttribute('aria-hidden', 'false')
          preorderViewEl?.setAttribute('aria-hidden', 'true')
          restockViewEl?.setAttribute('aria-hidden', 'true')

          this.hideOrderNoteIfMarketHasNoDeadline()

          this.setAttribute('aria-hidden', 'false')

          break
        case 'preorder':
          orderDeadlineViewEl?.setAttribute('aria-hidden', 'true')
          preorderViewEl?.setAttribute('aria-hidden', 'false')
          restockViewEl?.setAttribute('aria-hidden', 'true')
          this.setAttribute('aria-hidden', 'false')
          break
        case 'restock':
          orderDeadlineViewEl?.setAttribute('aria-hidden', 'true')
          preorderViewEl?.setAttribute('aria-hidden', 'true')
          restockViewEl?.setAttribute('aria-hidden', 'false')
          this.setAttribute('aria-hidden', 'false')
          break
        case 'unavailable':
          orderDeadlineViewEl?.setAttribute('aria-hidden', 'true')
          preorderViewEl?.setAttribute('aria-hidden', 'true')
          restockViewEl?.setAttribute('aria-hidden', 'true')
          this.setAttribute('aria-hidden', 'true')
          break
        default:
      }
    }, 200)
  }

  watchPurpleDot () {
    const targetElement = this.externalEls.form.element

    const mutationCallback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.id === 'pd-branding') {
              this.checkView()
              this.setAttribute('aria-hidden', 'false')
              observer.disconnect()
            }
          })
        }
      }
    }

    const observer = new MutationObserver(mutationCallback)

    const observerConfig = {
      childList: true,
      subtree: true,
    }

    observer.observe(targetElement, observerConfig)
  }

  watchOrderDeadline () {
    const targetElement = this.querySelector('.shopify-app-block')

    if (!targetElement) return

    const mutationCallback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (
            window.theme.strings.products.product
              .free_delivery_order_deadline_message &&
            window.Shopify.shop === 'oh-polly-uk.myshopify.com'
          ) {
            this.checkIfWeNeedToUpdateTheOrderDeadlineMessage()
          }

          this.checkView()
        }
      }
    }

    const observer = new MutationObserver(mutationCallback)

    const observerConfig = {
      childList: true,
      subtree: true,
    }

    observer.observe(targetElement, observerConfig)
  }

  checkIfWeNeedToUpdateTheOrderDeadlineMessage () {
    const eligibleForFreeDelivery = this.dataset.freeNextDayDelivery

    if (eligibleForFreeDelivery) {
      this.querySelector('.prd-OrderDeadlineApp').innerHTML =
        window.theme.strings.products.product.free_delivery_order_deadline_message
      this.els.deliveryNoteIcon.element.style.display = 'block'
    }
  }

  hideOrderNoteIfMarketHasNoDeadline () {
    const { isMappedMarket, shippingGroupPromise } = window.BAO.orderDeadline

    if (!isMappedMarket) {
      this.hideOrderNoteIfCustomerIsOutsideOfUK()

      return
    }

    shippingGroupPromise.then((shippingGroupId) => {
      this.setAttribute('aria-hidden', shippingGroupId ? 'false' : 'true')
    })
  }

  hideOrderNoteIfCustomerIsOutsideOfUK () {
    const activeShop = window.Shopify.shop

    if (activeShop !== 'oh-polly-uk.myshopify.com') return

    window.BAO.geoLocationPromise.finally(() => {
      const customerCountryCode = window.theme.customer.countryCode

      if (customerCountryCode !== 'GB') {
        this.setAttribute('aria-hidden', 'true')
      } else {
        this.setAttribute('aria-hidden', 'false')
      }
    })
  }

  variantHasRestock (variantId) {
    const restockByVariant = this.restockByVariant

    if (
      !Object.prototype.hasOwnProperty.call(restockByVariant, String(variantId))
    ) {
      return this.els.currentVariant.element.dataset.currentVariantRestock
    }

    return restockByVariant[String(variantId)] === true ? 'true' : 'false'
  }

  get restockByVariant () {
    const restockByVariantEl = this.els.restockByVariant?.element

    if (!restockByVariantEl) return {}

    try {
      return JSON.parse(restockByVariantEl.textContent)
    } catch (e) {
      return {}
    }
  }

  get view () {
    const formEl = this.externalEls.form?.element
    const isPreorderForm =
      formEl?.classList.contains('is-preorder-variant') ||
      formEl?.classList.contains('x-pd-atc-form--preorder')

    if (isPreorderForm) return 'preorder'

    const learnMoreEl = formEl?.querySelector('purple-dot-learn-more')
    if (learnMoreEl && learnMoreEl.getBoundingClientRect().height > 0) {
      return 'preorder'
    }
    if (
      this.els.currentVariant.element.dataset.currentVariantAvailable ===
      'false'
    ) {
      if (
        this.els.currentVariant.element.dataset.currentVariantRestock === 'true'
      ) {
        return 'restock'
      }

      return 'unavailable'
    }
    if (
      this.els.currentVariant.element.dataset.currentVariantAvailable === 'true'
    ) {
      return 'instock'
    }
  }
}

if (!customElements.get('shipping-notice')) {
  customElements.define('shipping-notice', ShippingNotice)
}
